// extracted by mini-css-extract-plugin
module.exports = {"curatorCard":"CXtLV","buttons":"_2qyjP","curatorName":"_2Oodw","showed":"_2efRB","curatorButton":"_2EurC"};